import { Controller } from "stimulus";

export default class extends Controller {
  connect() {}

  addDefaultNameToNewPool() {
    const poolNameInputs = document.querySelectorAll(".pool-name-input");
    const numberOfPools = poolNameInputs.length;
    poolNameInputs[numberOfPools - 1].querySelector(".bo-form-input").value = `Bassin ${numberOfPools}`;
  }
}
